/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToRem, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : COMMENTS COUNTER SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
    commentscounter: {
        '& .collapsable.opened': {
            maxHeight: pxToRem(3000)
        }
    }
});
